module.exports = __webpack_public_path__ + "img/cartIcon.007582b0.svg";